export const INVOICE_TEMPLATE_CODES = {
  MODERN_GST: "MODERN_GST",
  CLASSIC_STANDARD: "CLASSIC_STANDARD",
  COMPACT: "COMPACT",
  RETAIL: "RETAIL",
  SERVICE: "SERVICE",
  THERMAL: "THERMAL",
  PROFESSIONAL: "PROFESSIONAL",
  MINIMAL: "MINIMAL",
};

export const INVOICE_TEMPLATE_OPTIONS = [
  ["COMPACT", "Compact", "Dense A4 layout"],
  ["RETAIL", "Retail", "Retail/POS focused layout"],
  ["SERVICE", "Service", "Repair and service focused layout"],
  ["THERMAL", "Thermal", "80mm thermal receipt layout"],
  ["PROFESSIONAL", "Professional", "Formal corporate GST layout"],
  ["MINIMAL", "Minimal", "Clean monochrome layout"],
].map(([code, title, description]) => ({ code, title, description }));
